import React from 'react';
import { styled } from '@glitz/react';
import ArticleListViewModel from 'MagazineStart/ArticleListViewModel.type';
import TagButtons from './TagButtons';

const MobileTagWrap = styled.div({
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  // @ts-ignore
  '::-webkit-scrollbar': {
    display: 'none',
  },
  display: 'flex',
  gap: '12px',
  height: 'max-content',
  width: '100%',
  overflowX: 'scroll',
  padding: { y: '8px', left: '0px' },
  margin: { top: '-8px', bottom: '16px', left: '0px' },
})

const FilterTags = (props: {
  selectedTag: string;
  articleListViewModel: ArticleListViewModel;
  isCompact: boolean;
  onFilterClick: (number?: number, tag?: string) => void;
}) => {
  const { articleListViewModel, isCompact } = props;

  if (isCompact) {
    return (
      <MobileTagWrap>
        <TagButtons {...props} articleListViewModel={articleListViewModel} />
      </MobileTagWrap>
    );
  }

  return <TagButtons {...props} articleListViewModel={articleListViewModel} />;
};

export default FilterTags;